'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function useForceUpdate() {
  const [, setState] = React.useState({});
  return React.useCallback(() => setState({}), []);
}

exports.useForceUpdate = useForceUpdate;
